import { BREAKPOINT_SP } from './config'

/**
 * 指定classの親要素を返す関数
 * @params { HTMLElement } el
 * @params { string } targetClass
 */
export const closest = (el, targetClass) => {
  for (let item = el; item; item = item.parentElement) {
    if (item.classList.contains(targetClass)) {
      return item
    }
  }
}

/**
 * 指定要素の次の兄弟要素を返す関数
 * @params { HTMLElement } el
 * @params { string } selector
 */
export const next = (el, selector) => {
  if (selector && document.querySelector(selector) !== el.nextElementSibling) {
    return null;
  }
  return el.nextElementSibling;
}

/**
 * 画面サイズがSPか否か
 * @return boolean
 */
export const isSP = () => {
  return window.innerWidth <= BREAKPOINT_SP
}
